import bureaucrat from '../util/Bureaucrat';

function Logout() {
  return (
    <small>
      <a id="statusLogoutUri" href={bureaucrat.logoutUrl}>
        Logout
      </a>
    </small>
  );
}

export default Logout;
